import { createComputed, createSignal, Match, Show, Switch } from "solid-js"
import { A, useParams } from "@solidjs/router"
import { v4 as uuidv4 } from "uuid"
import { DataTypes, useLocalStore } from "@/context/StateContext"
import Editor from "@/components/Editor"
import Types from "@/types"
import { cn } from "@/utilities/cn"

export default function ItemsDetailView() {
  const params = useParams()
  const [itemId, setItemId] = createSignal(params.id)
  createComputed(() => setItemId(params.id))

  const localStore = useLocalStore()

  createComputed(async () => {
    if (!itemId() || !localStore.database) {
      return
    }
    // store that the user visited this item
    // await localStore.createSpecialConnection({
    //   origin: itemId(),
    //   type: Types.Visited,
    //   target: localStore.activeUserId!
    // })
  })

  const [loading, setLoading] = createSignal(false)
  const [error, setError] = createSignal<string | null>(null)
  const [item, setItem] = createSignal<any | null>(null)
  createComputed(async () => {
    if (!itemId() || !localStore.database) {
      return
    }
    setLoading(true)
    setError(null)
    try {
      const connections = await localStore.database.find({
        selector: {
          origin: itemId()
        }
      })
      if (connections.docs.length === 0) {
        setLoading(false)
        setError("No connections found")
        if (item()) {
          setItem(null)
        }
        return
      }
      const newItem: any = {}
      connections.docs.forEach((doc: any) => {
        newItem[doc.type] = doc.target
      })
      setLoading(false)
      setItem(newItem)
    } catch (error) {
      console.error(error)
      setLoading(false)
      setError(error.message)
    }
  })

  // always show the editor and allow for creation of connections => somone might have been sent a UUID to collect notes there in an offline scenario
  // should store when the user visited/edited the item tho

  return (
    <div class="flex flex-col h-full">
      <Show when={itemId()}>
        <Editor id={itemId()!} />
      </Show>
    </div>
  )
}
